<template>
  <div id="dashboard">
    <section class="is-flex pb-0">
      <card-component class="has-background-info has-text-white f-1 mb-0 mr-2">
        <div class="stat">
          <div>
            <div class="is-size-7 has-text-weight-bold">TOTAL GATEWAYS</div>
            <div class="is-size-5">{{ stats.totalGateways.toFixed(0) }}</div>
          </div>
          <b-icon icon="raspberry-pi" size="is-medium" />
        </div>
      </card-component>
      <card-component class="f-1 mb-0 mr-1">
        <div class="stat">
          <div>
            <div class="is-size-7 has-text-weight-bold">OFFLINE GATEWAYS</div>
            <div class="is-size-5">{{ stats.totalGateways.toFixed(0) }}</div>
          </div>
          <b-icon icon="raspberry-pi" size="is-medium" />
        </div>
      </card-component>
    </section>
  </div>
</template>

<script>
import animejs from 'animejs'

import { read as readGateway } from '@/api/gateway'

export default {
  name: 'Dashboard',
  data() {
    return {
      stats: {
        totalGateways: 0,
      },
    }
  },
  mounted() {
    readGateway()
      .then(res => this.initGatewayStats(res))
  },
  methods: {
    initGatewayStats(res) {
      animejs({
        targets: this.stats,
        totalGateways: res.data.gateways.length,
      })
    }
  }
}
</script>

<style lang="scss">
#dashboard {
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  // width: 99.1%;

  .stat {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
